import React, { useEffect, useState } from 'react'
import matter from 'gray-matter'
import { useParams, Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'

export default function LegalDoc() {
  const { doc } = useParams()
  const [content, setContent] = useState('')
  const [meta, setMeta] = useState({})
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const res = await fetch(`/api/legal/${doc}.md`)
        if (!res.ok) throw new Error('Failed to load document')
        const raw = await res.text()
        // Strip HTML comments (e.g., metadata blocks) to avoid rendering them
        const cleaned = raw.replace(/<!--[\s\S]*?-->/g, '')
        const parsed = matter(cleaned)
        // Dynamically replace hard-coded brand names with current host subdomain as brand
        const host = window.location.hostname || ''
        const brandSegment = host.split('.')[0] || ''
        const brandName = brandSegment
          .split(/[-_]/)
          .map(w => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ')
        const replaced = parsed.content
          .replace(/Longview Downtowners/gi, brandName)
          .replace(/Downtowners/gi, brandName)
        setMeta(parsed.data)
        setContent(replaced)
      } catch (err) {
        setError(err.message)
      }
    }
    fetchDoc()
  }, [doc])

  if (error) return <p className="p-4 text-error">Error: {error}</p>
  if (!content) return <p className="p-4">Loading...</p>

  return (
    <article className="legal-doc no-select">
      <Link to="/legal" className="text-accent hover:underline">
        &larr; Back to Legal Documents
      </Link>
      {/* Metadata block */}
      <section className="legal-meta">
        {meta.company && <p><strong>Company:</strong> {meta.company}</p>}
        {meta.jurisdiction && <p><strong>Jurisdiction:</strong> {meta.jurisdiction}</p>}
        {meta.effective_date && <p><strong>Effective Date:</strong> {meta.effective_date}</p>}
        {meta.version && <p><strong>Version:</strong> {meta.version}</p>}
        {meta.contact_email && (
          <p>
            <strong>Contact:</strong>{' '}
            <a href={`mailto:${meta.contact_email}`}>{meta.contact_email}</a>
          </p>
        )}
      </section>
      <div className="markdown-body">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </article>
  )
}